import moment from "../../../vendor/assets/javascripts/moment";

globalThis.moment = moment;
